export default "__VITE_ASSET__b47d47bd__"